<template>
  <div>
    <HEADER></HEADER>
    <!-- <div class="nc_about_header">
      <div class="banner">
        <img src="../assets/img/school/nc_school.jpg" alt />
      </div>
      <div class="w">
        <div class="about_content">
          <h1>NC大学</h1>
          <p>培养网络流量数据分析领域的专家</p>
        </div>
      </div>
    </div> -->
     <BANNER :src="banner_bg" h1='NC大学'  >
      <p>培养网络流量数据分析领域的专家</p>
    </BANNER>
    <div class="school_main" v-show='showCollege == true'>
      <div class="w">
        <div class="college">
          <h3>nCompass大学介绍</h3>
          <p>传统的网络流量分析称为数据包分析，通过抓包、过滤、解码几个标准动作分析网络流量数据里面的异常，协助诊断故障。长期以来，数据包分析是技术门槛较高且耗时费力的工作。随着nCompass产品的出现，传统数据包分析需要用到的各种数据都由机器分析并全粮入库，传统的看包动作已经转变为数据的消费过程，降低了网络流量分析的技术门槛，同时大大提高了分析效率。</p>
          <p>nCompass大学致力于培养网络流量数据分析领域的专家。学员将从简单的数据消费开始，逐步进入到按场景消费数据，设计场景，独立挖掘数据，最终达到将网络流量数据应用到运维、安全、业务管理当中。学员在学习nCompass产品的过程中，同时将学习到传统的TCP/IP、HTTP、DNS、DB等相关的协议知识，以保证协议知识与数据消费之间的融会贯通。</p>
        </div>
        <div class="level">
          <h3>nCompass大学专业等级认证</h3>
          <ul class="level_up">
            <li>
              <img src="../assets/img/school/ncp.png" alt="">
              <p>NCP</p>
              <p>nCompass专业技术认证</p>
              <div class="button" @click='toggle'>申 请 学 习</div>
              <a href="http://www.kaoshiyun.com.cn/l.html?t=76d1b0" target="_blank" rel="noopener noreferrer">
                <p>已有账号登陆</p>
              </a>
            </li>
            <li>
              <img src="../assets/img/school/ncm.png" alt="">
              <p>NCM</p>
              <p>nCompass专业技术认证</p>
              <div class="button" @click='toggle'>申 请 学 习</div>
              <a href="http://www.kaoshiyun.com.cn/l.html?t=76d1b0" target="_blank" rel="noopener noreferrer">
                <p>已有账号登陆</p>
              </a>
            </li>
            <li>
              <img src="../assets/img/school/nce.png" alt="">
              <p>NCE</p>
              <p>nCompass专业技术认证</p>
              <div class="button" @click='toggle'>申 请 学 习</div>
              <a href="http://www.kaoshiyun.com.cn/l.html?t=76d1b0" target="_blank" rel="noopener noreferrer">
                <p>已有账号登陆</p>
              </a>
            </li>
          </ul>
          <div class="tips">* 每个级别的认证均有相应的网上培训课程，必须完成对应课程的所有内容，并且技术认证考试达到80%正确率，才能够获得相应的等级证书。同时只有通过低级级别认证，才有资格申请更高级别的学习课程和认证。</div>
        </div>
      </div>
    </div>
    <div class="apply" v-show="showApply">
      <div class="w">
        <div class="title">欢迎您申请nCompass大学的专业认证课程</div>
        <form>
          <div class="email box">
            <label class="rule" for="email"><span class="fontRed">*</span>E-MAIL</label>
            <input type="email" @change="checkInput($event).check('email')" v-model="getInfo.email" id="email"> 请您填写真实邮箱，以便接受审核通过后的用户名和密码。
            <p class="warnning" v-show='checkList.email'>请输入正确的邮箱地址</p>
            <p class="warnning" v-show='ifEmpty.email'>邮箱地址不能为空</p>
          </div>
          <div class="name box">
            <label class="rule" for="name"><span class="fontRed" >*</span>真实姓名</label>
            <input type="text" @change="checkInput($event).check('name')" v-model="getInfo.name" id="name"> 学习通过后，颁发的证书需要打印您真实姓名。
            <p class="warnning" v-show='checkList.name'>请输入中文姓名</p>
            <p class="warnning" v-show='ifEmpty.name'>姓名不能为空</p>
          </div>
          <div class="position box">
            <label class="rule" for="position"><span class="fontRed">*</span>职位</label>
             <input type="text box" v-model="getInfo.job" id="position"> 请填写您的职位，保证申请信息的有效性。
              <p class="warnning" v-show='ifEmpty.job'>职位不能为空</p>
          </div>
          <div class="phone box">
            <label class="rule" for="mobile"><span class="fontRed">*</span>手机号码</label>
            <input type="text" @change="checkInput($event).check('phone')" v-model="getInfo.phone" id="mobile"> 接受信息和证书配送需要用到您的联系方式。
            <p class="warnning" v-show='checkList.phone'>请输入正确的手机号码</p>
            <p class="warnning" v-show='ifEmpty.phone'>手机号码不能为空</p>
          </div>
          <div class="compony box">
            <label class="rule" for="compony"><span class="fontRed">*</span>公司名称</label>
            <input type="text" v-model="getInfo.company" id="compony"> 请填写公司名称，保证申请信息的有效性。
            <p class="warnning" v-show='ifEmpty.company'>公司名称不能为空</p>
          </div>
          <div class="address box">
            <label class="rule" for="address"><span class="fontRed">*</span>邮寄地址</label>
            <input type="text" v-model="getInfo.address" id="address"> 配送证书的快递会用到您的详细地址。
            <p class="warnning" v-show='ifEmpty.address'>邮寄地址不能为空</p>
          </div>
          <div class="button" @click="getApply">提 交 申 请</div>
        </form>
      </div>
    </div>
    <div class="success" v-show="showSuccess">
      <div class="w">
        <div class="success_inner">
          <img src="../assets/img/school/success.svg" alt="">
          <p>信息提交成功，祝您学习愉快！</p>
          <span>您的信息已经提交到审核中心，我们会尽快发送审核结果到您的申请邮箱中，请注意查收！</span>
        </div>
      </div>
    </div>
    <WHO></WHO>
    <FOOTER></FOOTER>
  </div>
</template>

<script>
import HEADER from "../components/header.vue";
import FOOTER from "../components/footer.vue";
import WHO from "../components/who.vue";
import '../assets/iconfonts/iconfont.css';
import md5 from 'js-md5';
import BANNER from "../components/banner.vue";
import banner_bg from '../assets/img/school/nc_school.jpg';
export default {
  components: {
    HEADER,
    FOOTER,
    WHO,
    BANNER
  },
  data(){
    return{
      showCollege:true,
      showApply:false,
      showSuccess:false,
      banner_bg:banner_bg,
      checkList:{
        name:'',
        email:'',
        phone:'',
      },
      getInfo:{
        name:'',
        email:'',
        phone:'',
        job:'',
        company:'',
        address:''
      },
      ifEmpty:{
        name:'',
        email:'',
        phone:'',
        job:'',
        company:'',
        address:''
      },
      flag:"NcompassNetwork",
      timestamp:Date.now()
    }
  },
  methods:{
    toggle(){
      this.showCollege = false;
      this.showApply = true;
    },
    closeMask(){
      this.mask_show = false;
    },
    isOk(){
      var ok = true;
      var {name, email, phone} = this.checkList;
      for(var i in this.getInfo){
        if(this.getInfo[i] == ''){
          ok = false;
          this.ifEmpty[i] =  true;
        }
      }
      if(name||email||phone){
        ok = false;
      }
      return ok;
    },
    getApply(){
      if(this.isOk()){
          var fd = new FormData();
          fd.append('phone',this.getInfo.phone);
          fd.append('name',this.getInfo.name);
          fd.append('email',this.getInfo.email);
          fd.append('job',this.getInfo.job);
          fd.append('company',this.getInfo.company);
          fd.append('address',this.getInfo.address);

          fetch("https://www.ncmps.com/api/message",{
              method:"POST",
              body:fd,
              headers:{
                'timestamp':this.timestamp,
                'sign':md5(md5(`${this.timestamp}`)+`${this.flag}`)
              }
          }).then(res=>{
              res.json().then(json=>{
                if(json.code == 1){
                  this.showSuccess = true;
                  this.showApply = false;
                }else if(json.code == -1){
                  alert('电话号码或邮件地址已存在！');
                  return;
                }else{
                  return;
                }
              })
          })
      }else{
        return;
      }
    },
    checkInput(e){
      var val = e.currentTarget.value;
      var _this = this;
      var rules = {
        email(val){
          return  !/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(val);
        },
        phone(val){
          return  !/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/.test(val);
        },
        name(val){
          return !/^(?:[\u4e00-\u9fa5·]{2,16})$/.test(val);
        },
        isEmpty(val){
          return val == "";
        }
      };
      return {
        check(type){
          return rules[type] ? _this.checkList[type] = rules[type](val):  false;
        }
      }
    }
  },
  mounted(){

  }
};
</script>

<style lang='less'>
@import url("../assets/css/school.less");
</style>